const apoFpoStates = [
  { code: 'AA', name: 'APO/FPO America' },
  { code: 'AE', name: 'APO/FPO Europe' },
  { code: 'AP', name: 'APO/FPO Pacific' }
];

export default apoFpoStates;
